import * as vp from 'vopay';
import { useTranslation } from 'react-i18next';

type EditSignerRows = {
  label: string;
  id: vp.AddSignerId;
  preset: keyof vp.TextFieldPresets | undefined;
};

export default function useEditSignerRows(): EditSignerRows[] {
  const { t } = useTranslation('translations', { keyPrefix: 'Hooks.UseEditSignerRows' });

  return [
    {
      label: t('fullName', { defaultValue: 'Full Name*' }),
      id: vp.AddSignerId.AuthorizedFullLegalName,
      preset: 'text',
    },
    {
      label: t('emailAddress', { defaultValue: 'Email Address*' }),
      id: vp.AddSignerId.AuthorizedEmailAddress,
      preset: 'text',
    },
    {
      label: t('title', { defaultValue: 'Title*' }),
      id: vp.AddSignerId.AuthorizedOccupation,
      preset: 'text',
    },
  ];
}
